"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RemoveIconButton = exports.AddIconButton = void 0;
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
const AddIconButton = exports.AddIconButton = (0, _mui.styled)(_components.IconButton)(({
  theme
}) => ({
  marginTop: theme.spacing(2)
}));
const RemoveIconButton = exports.RemoveIconButton = (0, _mui.styled)(_components.IconButton)({
  marginLeft: 'auto'
});
